import { styled } from '@mui/system';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Blocks from '../../../assets/images/Blocks.png';
import ToolBar from '../ToolBar';
import LeftBar from '../LeftBar';
import { AppContext } from '../../../context/ContextProvider';
import { useContext } from 'react';

const Body = styled('div')({
  background: `url(${Blocks})`,
  width: '100%',
});
const ContentContainer = styled('div')({
  display: 'flex',
});

const PageBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isLogin',
})(({ isLogin, theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  marginTop: '60px',
  marginLeft: '60px',
  minHeight: 'calc(100vh - 60px)',
  background: `url(${Blocks})`,
  [theme.breakpoints.up('sm')]: {
    width: 'calc(100% - 60px)',
  },
  [theme.breakpoints.down('sm')]: {
    marginLeft: '0',
    minHeight: isLogin ? 'calc(100vh - 80px)' : 'calc(100vh - 30px)',
    marginTop: isLogin ? '80px' : '30px',
  },
}));

const ToolbarLayout = () => {
  const { isLogin } = useContext(AppContext);
  return (
    <Body>
      <ToolBar />
      <ContentContainer>
        <LeftBar />
        <PageBox isLogin={isLogin}>
          <Outlet />
        </PageBox>
      </ContentContainer>
    </Body>
  );
};

export default ToolbarLayout;
